module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_container"
  }, [_c('main-header', {
    attrs: {
      "title": this.$route.name
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show_loader) ? _c('div', {
    staticClass: "loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.loader_src
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "slide",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    on: {
      "hideLoader": _vm.hideLoader
    }
  })], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "showmodal": _vm.show_modal
    },
    on: {
      "hideModal": _vm.hideModal
    }
  })], 1), _vm._v(" "), _c('main-footer', {
    on: {
      "showModal": _vm.showModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 574
// module chunks = 1